import { ClientService, CommonService, SplashScreenStateService } from '@fitness-force/api';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, } from '@angular/core';
import { Observable, BehaviorSubject, forkJoin, map, of } from 'rxjs';
import { DataGridComponent, NoComponentComponent } from '@fitness-force/grid';
import {
  getCutomDate,
  timeLineService,
  RouteStateService
} from '@fitness-force/shared';
import { dateCollection } from '@fitness-force/pipes/datetime-format';
import { DividerModule } from 'primeng/divider';
import { TimelineModule } from 'primeng/timeline';

import { TableModule } from 'primeng/table';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { StyleClassModule } from 'primeng/styleclass';
import { ToastMessageService } from '@fitness-force/api';
import { AppErrors, BadRequestError, NotFoundError } from '@fitness-force/errors';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { PlanIntervalType, StaffStatus, Ienum, SubscriptionStatus, PayModeLevel1, SignUpMode, PlanCategory, OccurenceType, PayModeLevel2 } from '@fitness-force/enum';
import { CONSTANTS_DATA } from '@fitness-force/constants';
import { InvoiceTabComponent } from '../../../transaction-tab/invoice-tab/invoice-tab.component';
import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';
import { CurrencyComponent } from '@fitness-force/grid-utility/currency'
import { InvoiceDetailsComponent } from '../../invoice-details/invoice-details.component';

import { MessageModule } from 'primeng/message';
import { DialogModule } from 'primeng/dialog';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { InvoiceOccurance, PaymentMethod, PlanAddons, PlanSummary, PlanSummaryClient, SubscriptionById, SubscriptionDeposit, TENANTSINTERFACE } from '@fitness-force/models';
import { PaymentTimelineComponent } from '../payment-timeline/payment-timeline.component';
import { SubscriptionServicesComponent } from '../subscription-services/subscription-services.component';
import { SubscriptionStartEndDateEditComponent } from '../subscription-start-end-date-edit/subscription-start-end-date-edit.component';
import Statsig from 'statsig-js';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayModule } from 'primeng/overlay';
import { PopoverModule } from 'primeng/popover';
import { BillingComponent } from '@fitness-force/billing';
import { SubscriptionActionListComponent } from '../../../subscription-action-list/subscription-action-list.component';
import { DepositNameComponent } from '../../../data-grid/utility/deposit-name/deposit-name.component';
import { SkeletonModule } from 'primeng/skeleton';


@Component({
  selector: 'subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.scss'],
  providers: [ToastMessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule,
    DividerModule,
    TimelineModule,
    DateTimeFormatPipe,
    CurrencyformatPipe,
    TableModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    SelectModule,
    AvatarModule,
    TagModule,
    StyleClassModule,
    DataGridComponent,
    InvoiceDetailsComponent,
    RouterModule,
    InvoiceTabComponent,
    MessageModule,
    DialogModule,
    SubscriptionServicesComponent,
    PaymentTimelineComponent,
    SubscriptionStartEndDateEditComponent,
    ConfirmDialogModule,
    ConfirmPopupModule,
    OverlayModule,
    PopoverModule,
    BillingComponent,
    SubscriptionActionListComponent,
    SkeletonModule,
    TranslateModule],
})
export class SubscriptionDetailsComponent implements OnInit {
  @Input('clientId') clientId: number = 0;
  @Input('subscriptionId') subscriptionId: number = 0;
  @Output('emitEvents') emitEvents: EventEmitter<any> = new EventEmitter();
  @Input('subscription') selectedSubscription: any;
  @Input('allSubscription') allSubscription: any;

  tenantId: number = 0;
  subscriptionDetailsContract: boolean = false;
  paymentTimeline: any[] = [];
  paymentStatus: any[] = [];
  subscriptionDetailsPaidFull: boolean = false;
  subscriptionDetailsDropin: boolean = false;
  showsubscriptionDetails: boolean = false;
  clientSubScriptionId: number | null = null;
  invoiceData = new BehaviorSubject<any>([]);
  paymentTimelineData = new BehaviorSubject<InvoiceOccurance[]>([]);
  clientSubscriptionData = new BehaviorSubject<any>({});
  columns: any = new BehaviorSubject([]);
  showBulkActionBar = false;
  selecallInvoiceData = new BehaviorSubject(false);
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent);
  allParams = new Map();
  totalRecordLength = new BehaviorSubject({
    totalPage: 10,
    totalItems: 10,
    currentPage: 0,
  });
  invoiceDetails: any;
  invoiceId: any;
  showInvoicePopup: boolean = false;
  assignSessionOwnerModal = false;
  _sessionOwner = new BehaviorSubject<number[]>([0]);
  getAccessedStaffList$: Observable<any> | any;
  showSessionOwner: boolean = false;
  currentYear = new Date();
  subscriptionService$ = new BehaviorSubject<any[]>([]);
  serviceTablecolumns$: any = new BehaviorSubject([]);
  showAddonSidebar: boolean = false;
  showBillingSidebar = false;
  showPaymentStatusSidebar = false;

  showDeposit: boolean = false;

  weekDays = [
    { key: 'Sunday', value: -1 },
    { key: 'Monday', value: -2 },
    { key: 'Tuesday', value: -3 },
    { key: 'Wednesday', value: -4 },
    { key: 'Thursday', value: -5 },
    { key: 'Friday', value: -6 },
    { key: 'Saturday', value: -7 },
  ];

  days: Array<string> = CONSTANTS_DATA.DAYS;
  contractExpiry: any[] = [];
  changeSessionOwnerForm: UntypedFormGroup = new UntypedFormGroup({});
  currentDate: Date = new Date();
  allServices = new BehaviorSubject<any>([]);
  showCancelSubscription: boolean = false;
  showEditStartEndDate: boolean = false;
  subscriptionById: SubscriptionById;
  membershipId: number = 0;
  showVoidSubscriptionModal: boolean = false;
  voidSubscriptionForm: UntypedFormGroup = new UntypedFormGroup({});
  ActivateMebershipForm: UntypedFormGroup = new UntypedFormGroup({});
  subscriptionDetails: any;
  btnLoading = new BehaviorSubject<boolean>(false);
  allTenants: any;
  showTransfer: boolean = false;
  error = new BehaviorSubject(null as AppErrors | null);
  showErrorPopup = new BehaviorSubject(false);
  errorMessages = [] as any;
  HideErrorPopup(event: any) {
    this.showErrorPopup?.next(false);
    this.errorMessages = [];
  }
  upgradedSubscription: boolean = false;
  ActivateMembershipPopup: boolean = false;
  addDiscountedPeriod: boolean = false;
  clientDetails: any;
  showFreeDiscountApply = new BehaviorSubject(false);
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);
  planId: number = 0;
  planSummarydataObject: Observable<PlanSummary> | any;
  depositsTableData: any[];
  depositTablecolumns: any = new BehaviorSubject([]);
  depositTableData = new BehaviorSubject<SubscriptionDeposit[]>([]);
  isTenantPresale = new BehaviorSubject<boolean>(false);
  showSkeleton$ = new BehaviorSubject<boolean>(true);

  constructor(
    private store: Store,
    private translate: TranslateService,
    private clientService: ClientService,
    private toastMessageService: ToastMessageService,
    private router: Router,
    public datePipe: DatePipe,
    private fb: UntypedFormBuilder,
    public cd: ChangeDetectorRef,
    private routerservice: RouteStateService,
    public splashScreen: SplashScreenStateService,
    private commonService: CommonService,
  ) {

    this.depositsTableData = [
      { deposits: 'Deposit 1', auto_apply: true, occurence: '11 Billing Occurrence', status: "Applied", amount: "$2500.00" },
      { deposits: 'Deposit 2', auto_apply: true, occurence: 'Last Billing Occurrence', status: "Scheduled", amount: "$1900.00" },
      { deposits: 'Deposit 3', auto_apply: false, occurence: '', status: "Pending", amount: "$3000.00" },
    ];
  }

  ngOnInit(): void {
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.allTenants = tenant.all_tenant;
    });

    this.componentInit();
    if (Statsig.checkGate("show_transfer")) {
      this.showTransfer = true;
    }
    if (Statsig.checkGate("show_add_discount_on_billing_cycle")) {
      this.showFreeDiscountApply.next(true);
    }

  }
  componentInit() {
    this.allParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.allParams.set('PageSize', { name: 'PageSize', value: 10 });
    this.voidSubscriptionForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
    });
    this.ActivateMebershipForm = this.fb.group({
      change_reason: ['', [Validators.required]],
    });
    
    this.store.select(TENANTS_INFO).subscribe((res:TENANTSINTERFACE) => {
      if (res) {
        this.isTenantPresale.next(res.all_tenant.find(o => o.id == this.tenantId)?.status.toLowerCase() === 'presales');
      }
    });
    
    this.getSubscriptionDetailsById();
  }

  getSubscriptionDetailsById() {
    forkJoin({
      subscription: this.clientService.getSubscriptionDetails(
        this.clientId,
        this.subscriptionId
      ),
      paymentTimeline: this.clientService.getPaymentTimeline(
        this.clientId,
        this.subscriptionId
      ),
    })
      .pipe(
        map((response) => {
          const subscription = response.subscription as SubscriptionById;
          subscription.scheduled_cancellation_date = this.isMinimumDateTimeValue(subscription.scheduled_cancellation_date) ? subscription.scheduled_cancellation_date : subscription.scheduled_cancellation_date;
          this.planId = subscription.plan_id;
          this.clientSubscriptionData.next(subscription);
          this.subscriptionById = subscription;
          this.paymentTimelineData.next(response.paymentTimeline.invoice_occurance ? response.paymentTimeline.invoice_occurance : []);
          this.SetDepositDetails();
          this.showSkeleton$.next(false);
        })
      )
      .subscribe({
        error: (error: any) => {
            this.toastMessageService.showError(error);
        },
      });

    this.cd.detectChanges();
  }

  getSubscription(subscriptionId: number) {
    this.subscriptionId = subscriptionId;
    this.paymentTimelineData.next([]);
    this.clientSubscriptionData.next(null);
    this.getSubscriptionDetailsById();
    this.cd.detectChanges();
  }

  handleEvent(e: any) {
    this.componentInit();
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
    } else {
      this.showBulkActionBar = false;
    }
  }


  formatDate(d: any) {
    const parseDate = `${d.getFullYear()}-${d.getMonth() > 9 ? d.getMonth() : d.getMonth() + 1}-${d.getDate()}`;
    return parseDate.toString();
  }

  BacktoAllSubscriptions() {
    this.subscriptionDetailsContract = false;
    this.subscriptionDetailsPaidFull = false;
    this.subscriptionDetailsDropin = false;
    this.showsubscriptionDetails = false;
  }

  showAllSubscriptions() {
    if (
      this.subscriptionDetailsContract == false &&
      this.subscriptionDetailsPaidFull == false &&
      this.subscriptionDetailsDropin == false
    ) {
      return true;
    } else {
      return false;
    }
  }

  billingInterval(interval_type: string, interval_value: number): string {
    if (
      interval_value &&
      interval_type.toLowerCase() == 'month' &&
      interval_value
    ) {
      if (interval_value == 1) {
        return 'Month';
      } else if (interval_value == 3) {
        return 'Quater';
      } else if (interval_value == 6) {
        return 'Half yearly';
      } else {
        return interval_type;
      }
    } else {
      return interval_type;
    }
  }
  ordinalSuffixOfBillingCycle(billingCycleDate: number) {
    const billingCycleDateBuff = billingCycleDate % 10;
    const billingCycleDateBuffAvg = billingCycleDate % 100;
    if (billingCycleDateBuff == 1 && billingCycleDateBuffAvg != 11) {
      return 'st';
    }
    if (billingCycleDateBuff == 2 && billingCycleDateBuffAvg != 12) {
      return 'nd';
    }
    if (billingCycleDateBuff == 3 && billingCycleDateBuffAvg != 13) {
      return 'rd';
    }
    return 'th';
  }

  GetBillingFrequency(interval_type: string, interval_value: number, billingCycleDay: number): string {
    let translate: string = '';
    if (interval_value && interval_type.toLowerCase() == 'month') {
      const ordinalSuffix = this.ordinalSuffixOfBillingCycle(billingCycleDay);
      if (interval_value == 1) {
        this.translate.get('SUBSCRIPTIONS.ONE_MONTH_TYPE', {
          billingCycleDay: billingCycleDay,
          ordinalSuffix: ordinalSuffix,
        }).subscribe((trans) => {
          translate = trans;
        });
      } else if (interval_value == 2) {
        this.translate.get('SUBSCRIPTIONS.TWO_MONTH_TYPE', {
          billingCycleDay: billingCycleDay,
          ordinalSuffix: ordinalSuffix,
        }).subscribe((trans) => {
          translate = trans;
        });
      } else if (interval_value == 3) {
        this.translate.get('SUBSCRIPTIONS.THREE_MONTH_TYPE', {
          billingCycleDay: billingCycleDay,
          ordinalSuffix: ordinalSuffix,
        }).subscribe((trans) => {
          translate = trans;
        });
      } else {
        this.translate.get('SUBSCRIPTIONS.MORE_MONTH_TYPE', {
          intervalValue: interval_value,
          billingCycleDay: billingCycleDay,
          ordinalSuffix: ordinalSuffix,
        }).subscribe((trans) => {
          translate = trans;
        });
      }
      return translate;
    } else if (interval_value && interval_type.toLowerCase() == 'week') {
      let day: string = '';

      if (billingCycleDay == 0)
        day = this.days[new Date(this.clientSubscriptionData.value.sign_up_date).getDay()];
      else
        day = this.weekDays.find((d) => d.value == billingCycleDay)?.key || '';

      if (interval_value == 1) {
        this.translate.get('SUBSCRIPTIONS.WEEKLY_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else if (interval_value == 2) {
        this.translate.get('SUBSCRIPTIONS.2WEEK_SUNDAY', { day: day })
          .subscribe((trans) => {
            translate = trans;
          });
      } else {
        this.translate.get('SUBSCRIPTIONS.MORE_WEEK', {
          intervalType: interval_value,
          day: day,
        }).subscribe((trans) => {
          translate = trans;
        });
      }
      return translate;
    } else {
      return interval_type;
    }
  }

  transFerInitials(maxAllowedDays: any, startDate: any) {
    const transferAllowedDate = timeLineService(getCutomDate(maxAllowedDays, startDate));
    return transferAllowedDate.type == 'ago' ? '0 Days' : transferAllowedDate.label;
  }

  cancellationDateAllowed(date: any) {
    timeLineService;
    return timeLineService(date);
  }

  isDefaultDate(date: string): boolean {
    const year = new Date(date).getFullYear();
    return year == 9999;
  }

  backToSubscription() {
    this.router.navigate(['/client/profile', this.clientId]);
  }

  getInterval(billing_interval_value: number, billing_interval_type: PlanIntervalType) {
    let str: string = '';
    if (
      billing_interval_type == PlanIntervalType.Month || billing_interval_type?.toString() == PlanIntervalType[PlanIntervalType.Month]
    ) {
      if (billing_interval_value > 1) str = 'months';
      else str = 'month';
    } else if (
      billing_interval_type == PlanIntervalType.Week || billing_interval_type.toString() == PlanIntervalType[PlanIntervalType.Week]
    ) {
      if (billing_interval_value > 1) str = 'weeks';
      else str = 'week';
    }
    else if (
      billing_interval_type == PlanIntervalType.Day || billing_interval_type == PlanIntervalType[PlanIntervalType.Day]) {
      if (billing_interval_value > 1) str = 'days';
      else str = 'day';
    }
    return str.toUpperCase();
  }

  onActionEvent(event: any) {
    switch (event.action) {
      case 'openinvoice':
        {
          this.OpenInvoicePopup(event.columnData);
        }
        break;
    }
  }

  OpenInvoicePopup(invoiceNumber: string) {
    this.invoiceDetails = this.invoiceData.value.find(
      (i: { number_prefix: string }) => i.number_prefix == invoiceNumber
    );
    this.invoiceId = this.invoiceDetails.id;
    this.showInvoicePopup = true;
  }

  closeInvoicePopup(event: any) {
    this.showInvoicePopup = event;
  }

  getSessionOwnerFC(serviceId: string): AbstractControl | null {
    return this.changeSessionOwnerForm.get(serviceId);
  }

  ShowToastErrors(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }

  }

  getAllServices() {
    const services: any = [];
    if (this.clientSubscriptionData && this.clientSubscriptionData.value.recurring_template_recurring_services) {
      this.clientSubscriptionData.value.recurring_template_recurring_services.forEach(
        (value: any) => {
          if (value.service_behaviour == "AppointmentPackage") {
            services.push(value);
            this.showSessionOwner = true;
            this.changeSessionOwnerForm.addControl('SelectedAssignedFormControl_' + value.service_id.toString(), new UntypedFormControl(value.service_session_owner_id, []));
          }
        }
      );
    }
    if (this.clientSubscriptionData && this.clientSubscriptionData.value.recurring_template_non_recurring_services) {
      this.clientSubscriptionData.value.recurring_template_non_recurring_services.forEach(
        (value: any) => {
          if (value.service_behaviour == "AppointmentPackage") {
            services.push(value);
            this.showSessionOwner = true;
            this.changeSessionOwnerForm.addControl('SelectedAssignedFormControl_' + value.service_id.toString(), new UntypedFormControl(value.service_session_owner_id, []));
          }
        }
      );
    }
    this.allServices.next(services);
    return this.allServices;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }

  getSessionOwnerId(sessionOwnerId: number) {
    return new BehaviorSubject(sessionOwnerId);
  }

  isDateStartingAfterToday(startDate: Date) {
    return startDate.getFullYear() > this.currentDate.getFullYear() &&
      startDate.getDate() > this.currentDate.getDate() &&
      startDate.getMonth() > this.currentDate.getMonth();
  }

  dateTransform(date: Date) {
    return this.datePipe.transform(date, 'dd MMM yyyy')
  }

  isMinimumDateTimeValue(eta: Date): boolean {
    return new Date(eta).getTime() === new Date('0001-01-01T00:00:00').getTime();
  }

  GoToCancel(subscription: any) {
    this.showCancelSubscription = true;
  }

  closeEvent(event: any) {
    this.showCancelSubscription = false;
    this.clientSubscriptionData.next(event);
  }

  showWaringMessage() {
    this.translate.get('SUBSCRIPTIONS.SUBSCRIPTION_CANCELLED')
      .subscribe((translation) => {
        this.toastMessageService.showInfo(translation);
      });
  }

  closeDateChangeEvent(event: any) {
    this.showEditStartEndDate = false;
    this.subscriptionById = event;
    this.clientSubscriptionData.next(event);
  }

  reloadData(event: boolean) {
    if (event) this.componentInit();
  }

  showSubscriptionStatus(status: string) {
    let colorCode: string = "";
    const data = SubscriptionStatus[status as keyof typeof SubscriptionStatus]
    switch (data) {
      case SubscriptionStatus.Active:
        colorCode = "bg-green-500"
        break;
      case SubscriptionStatus.Future:
        colorCode = "bg-bluegray-100"
        break;
      case SubscriptionStatus.Cancelled:
        colorCode = "bg-bluegray-500"
        break;
      case SubscriptionStatus.Frozen:
        colorCode = "bg-cyan-500"
        break;
      case SubscriptionStatus.CancelledDueToNonPayment:
        colorCode = "surface-500"
        break;
      case SubscriptionStatus.NotRenewing:
        colorCode = "surface-500"
        break;
      case SubscriptionStatus.PendingForMandatoryAction:
        colorCode = "bg-pink-500"
        break;
      case SubscriptionStatus.PendingForPaymentConfirmation:
        colorCode = "bg-orange-500"
        break;
      case SubscriptionStatus.SuspendedDueToNonPayment:
        colorCode = "surface-600"
        break;
      case SubscriptionStatus.Transfered:
        colorCode = "bg-indigo-500"
        break;
      case SubscriptionStatus.Upgraded:
        colorCode = "bg-teal-500"
        break;
      case SubscriptionStatus.Expired:
        colorCode = "bg-red-500"
        break;
      case SubscriptionStatus.Void:
        colorCode = "surface-500"
        break;
    }
    return colorCode;
  }

  isRecurringSubscription(subscription: any) {
    return subscription.subscription_category == PlanCategory.Contract || subscription.subscription_category.toString() == PlanCategory[PlanCategory.Contract]
    || subscription.subscription_category == PlanCategory.PayAsYouGo || subscription.subscription_category.toString() == PlanCategory[PlanCategory.PayAsYouGo]
  }

  hasSubscription(subscription: any) {
    return subscription && Object.keys(subscription).length > 0;
  }

  hasUpgradeSubscription(subscription: any) {
    return subscription.upgrade_from_clt_subs_id > 0 || subscription.upgrade_to_clt_subs_id > 0;
  }

  isPayAsYouGoSubscription(subscription: any) {
    return subscription.subscription_category == PlanCategory.ConvertToPayAsYouGo || subscription.subscription_category.toString() == PlanCategory[PlanCategory.ConvertToPayAsYouGo];
  }

  get SubscriptonStatus() {
    return SubscriptionStatus
  }

  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidSubscriptionForm.controls.void_reason as UntypedFormControl;
  }

  get ChangeReasonFormControl(): UntypedFormControl {
    return this.ActivateMebershipForm.controls.change_reason as UntypedFormControl;
  }

  IsSubscrptionVoidOrCancelled(status: string) {
    const subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Void || subscrptionStatus == SubscriptionStatus.Cancelled || subscrptionStatus == SubscriptionStatus.Upgraded);
  }

  CanEditDates(status: string) {
    const subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (subscrptionStatus == SubscriptionStatus.Void
      || subscrptionStatus == SubscriptionStatus.Cancelled
      || subscrptionStatus == SubscriptionStatus.Frozen
      || subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment
      || subscrptionStatus == SubscriptionStatus.Upgraded
      || subscrptionStatus == SubscriptionStatus.Transfered
      || subscrptionStatus == SubscriptionStatus.NotRenewing
      || subscrptionStatus == SubscriptionStatus.CancelledDueToNonPayment);
  }

  getTenant(tenantId: number) {
    return this.allTenants.find((o: { id: number; }) => o.id == tenantId);
  }

  get IsUpgraded() {
    if(this.subscriptionById){
      const subscrptionStatus = SubscriptionStatus[this.subscriptionById.status as keyof typeof SubscriptionStatus];
      return (subscrptionStatus == SubscriptionStatus.Upgraded);
    }
    return false;
  }

  getSubscriptionDetails(subscription: any) {
    const subscrptionStatus = SubscriptionStatus[subscription.status as keyof typeof SubscriptionStatus];
    if (subscrptionStatus == SubscriptionStatus.Upgraded) return this.allSubscription.find((o: { id: any; }) => o.id == subscription.upgrade_to_clt_subs_id);
    else if (subscrptionStatus == SubscriptionStatus.Active && subscription.upgrade_to_clt_subs_id > 0) return this.allSubscription.find((o: { id: any; }) => o.id == subscription.upgrade_to_clt_subs_id);
    else return this.allSubscription.find((o: { id: any; }) => o.id == subscription.upgrade_from_clt_subs_id);
  }

  PaymentMethodDetails(paymentMethod: PaymentMethod) {
    const paymentData: any = {};
    const data = PayModeLevel1[paymentMethod.level1.toString() as keyof typeof PayModeLevel1]
    const level2 = PayModeLevel2[paymentMethod.level2.toString() as keyof typeof PayModeLevel2]
    switch (data) {
      case PayModeLevel1.Cash:
        paymentData.img = "/assets/img/icons/icon-cash.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.ACH:
        paymentData.img = "/assets/img/ach-options.svg.png";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Adjustment:
        paymentData.img = "/assets/img/icons/icon-adjustment.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Card:
        if (paymentMethod.network_type.toLowerCase() == "mastercard")
          paymentData.img = "/assets/img/mastercard.png";
        else
         paymentData.img = "/assets/img/visa.png";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: paymentMethod.masked_card_number })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });

        break;
      case PayModeLevel1.Cheque:
        paymentData.img = "/assets/img/icons/icon-cheque.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Emandate:
        paymentData.img = "/assets/img/icons/icon-emandate.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.NetBanking:
        paymentData.img = "/assets/img/bank-payment-img.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: paymentMethod.masked_account_number ? paymentMethod.masked_account_number : "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.UPI:
        paymentData.img = "/assets/img/logo-upi.svg";
        paymentData.icon ='fab fa-cc-visa';
        paymentData.number = paymentMethod.vpa_id;
        break;
      case PayModeLevel1.Wallet:
        if(level2 == PayModeLevel2.ApplePay)
        {
          paymentData.img = "/assets/img/apple-logo.jpg";
          paymentData.icon ='fab fa-apple-pay';
        }
        else if(level2 == PayModeLevel2.GooglePay)
        {
          paymentData.img = "/assets/img/googleplay-logo.jpg";
          paymentData.icon ='fab fa-google-pay';
        }
        else
        {
          paymentData.img = "/assets/img/icons/icon-wallet.svg";
          paymentData.icon ='fab fa-cc-visa';
        }
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: paymentMethod.masked_account_number ? paymentMethod.masked_account_number : "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.Other:
        paymentData.img = "/assets/img/icons/icon-others-method.svg";
        paymentData.icon ='fab fa-cc-visa';
        this.translate
          .get('SUBSCRIPTIONS.CARD-ENDING-WITH', { number: "****" })
          .subscribe((translations: any) => {
            paymentData.number = translations;
          });
        break;
      case PayModeLevel1.PayTo:
        paymentData.img = "/assets/img/icons/icon-payto.svg";
        paymentData.icon ='fab fa-cc-visa';
        paymentData.number =  paymentMethod.pay_to_details;
        break;
    }
    return paymentData;
  }

  closeAddonSidebar(event: { event: any, subscription: any }) {
    this.showAddonSidebar = false;
    this.splashScreen.showSpinner();
    this.cd.detectChanges();
    this.selectedAddons.next(event.event.selectedAddons);
    if (this.selectedAddons.value.length > 0 && event.event.callbreakup) {
      const client = this.routerservice.getClient();
      const planSummaryClient = {} as PlanSummaryClient;
      planSummaryClient.client_id = this.clientId;
      planSummaryClient.client_name = client!.full_name;
      planSummaryClient.client_keyfob = client!.current_keyfob;
      planSummaryClient.client_image = client!.image;
      if (client!.client_status)
        planSummaryClient.client_status = client!.client_status.toString();

      const planSummary = {} as PlanSummary;
      planSummary.id = this.planId;
      planSummary.company_id = this.subscriptionById.company_id;
      planSummary.tenant_id = this.subscriptionById.tenant_id;
      planSummary.plan_selectable = false;
      planSummary.client = planSummaryClient;
      planSummary.from_subscription_id = this.subscriptionById.id;
      planSummary.SignUpMode = SignUpMode.MidCycleAddons;
      planSummary.addons = this.selectedAddons.value;
      this.planSummarydataObject = of(planSummary);
      setTimeout(() => {
        this.showBillingSidebar = true;
        this.splashScreen.hideSpinner();
        this.cd.detectChanges();
      }, 300);
    }
    else {
      this.showBillingSidebar = false;
      this.splashScreen.hideSpinner();
      this.cd.detectChanges();
    }
  }

  HideBillingSummary(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  GoToClientDetails(event: any) {
    this.showBillingSidebar = false;
    this.showAddonSidebar = false;
  }

  isNotRenewingStatus(status: string) {
    const subscrptionStatus = SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.NotRenewing;
  }

  SetDepositDetails() {
    if (this.subscriptionById && this.subscriptionById.subscription_deposit && this.subscriptionById.subscription_deposit.length > 0) {
      this.showDeposit = true;
      const addedDeposits: any = [];
      this.subscriptionById.subscription_deposit.forEach((element: any, index: number) => {
        const deposit: SubscriptionDeposit = {} as SubscriptionDeposit;
        const occurences = this.commonService.generateDepositOccurence(element.occurence_type, this.subscriptionById.subscription_category == PlanCategory.Contract ? this.subscriptionById.contract_term : 24)
        deposit.occurence_to_apply = element.occurence_to_apply;
        deposit.occurence_type = element.occurence_type;
        deposit.occurence_amount_in_minor_currency = element.occurence_amount_in_minor_currency;
        if (element.occurence_type == OccurenceType.ApplyManually || element.occurence_type.toString() == OccurenceType[OccurenceType.ApplyManually]) {
          deposit.occurence_to_apply = element.occurence_to_apply;
          deposit.occurence_name = "-";
        }
        else {
          deposit.occurence_name = occurences.find(o => o.value == element.occurence_to_apply)?.key || '';
        }
        this.translate.get('DEPOSIT.DEPOSIT_NAME', { count: index + 1 })
          .subscribe((translations) => {
            deposit.deposit_name = translations;
          });
        addedDeposits.push(deposit);
      });
      this.depositTableData.next(addedDeposits);
      this.columnTranslate();
    }
    else {
      this.showDeposit = false;
    }
  }

  columnTranslate() {
    this.translate
      .get([
        'DEPOSIT.DEPOSIT',
        'DEPOSIT.OCCURRENCE',
        'DEPOSIT.AMOUNT'
      ])
      .subscribe((translations) => {
        this.SetDepositColumns(translations);
      });
  }

  SetDepositColumns(translations: any) {
    const column = {
      deposit: translations['DEPOSIT.DEPOSIT'],
      occurence: translations['DEPOSIT.OCCURRENCE'],
      amount: translations['DEPOSIT.AMOUNT'],
    };
    this.depositTablecolumns.next([
      {
        title: column.deposit,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'deposit_name',
        type: 'component',
        data: {
          name: DepositNameComponent,
        },
      },
      {
        title: column.occurence,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'occurence_name',
        type: 'default',
      },
      {
        title: column.amount,
        classes: 'py-2  white-space-nowrap bold relative  capitalize',
        dataProperty: 'occurence_amount_in_minor_currency',
        type: 'component',
        data: {
          name: CurrencyComponent,
          fetch_key: 'occurence_amount_in_minor_currency',
        },
      }
    ]);
  }


  isPresalePurchased(subscription: any) {
    return subscription.is_presale;
  }

  ActionsEmitEvents(event: any) {
    this.emitEvents.emit(event);
    if (event)
      this.componentInit();
  }

  getTagStyle(tokenStatus: string): string {
    switch (tokenStatus) {
      case 'initiated':
        return 'text-primary';
      case 'confirmed':
        return 'text-green-500';
      case 'rejected':
        return 'text-bluegray-500';
      case 'cancelled':
        return 'text-red';
      case 'paused':
        return 'text-orange-500';
      default:
        return '';
    }
  }

  get showSkeleton() {
    return this.showSkeleton$.value;
  }

}
